import React from "react";
import { Button } from "react-bootstrap";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import progressImage from '../../../../../styles/img/home-car-img.png';
import volvoLogo from '../../../../../styles/img/volvo-logo-round.png';
import ToyotaLogo from "../../../../../styles/img/toyotalogo.png"
import { Link } from "react-router-dom";

export const KnowledgeProgress = () => {
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12">
                        <UiContentCol>
                            <div className="sb-knw-progress-sec">
                                <UiSingleRow>
                                    <UiCardTitle title="Your Progress" underlined={true} />
                                    <UiCol lg="2">
                                        <div className="sb-knw-progress-sec__quiz-box">
                                            <div>
                                                <h4>18/50</h4>
                                                <p>Quizzes Taken</p>
                                            </div>
                                        </div>
                                    </UiCol>

                                    <UiCol lg="7">
                                        <div className="sb-knw-progress-sec__desc">
                                            <div className="sb-progress-desc">
                                                <h3>Earn 500 points!</h3>
                                                <p>Discover the new Volvo range today and pick up quick and easy points!</p>
                                                <Link to="/ui/quiz-home">
                                                    <Button to="" className="sb-primary-btn--38">Start !</Button></Link>
                                            </div>
                                            {/* <img src={ToyotaLogo} /> */}
                                        </div>
                                    </UiCol>

                                    <UiCol lg="3">
                                        <img src={progressImage} className="sb-knw-progress-sec__progress_img" />
                                    </UiCol>

                                </UiSingleRow>
                            </div>
                        </UiContentCol>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}
